import { useEffect, useState } from "react";

function Game() {
  const [activePlayer, setActivePlayer] = useState(true);
  const [activeCircle, setActiveCircle] = useState([]);
  const [activeCircleForPlayAgain, setActiveCircleForPlayAgain] = useState([]);
  const [canPlayAgain, setCanPlayAgain] = useState([]);
  const [nextStepLeft, setNextStepLeft] = useState([]);
  const [nextStepRight, setNextStepRight] = useState([]);
  const [backNextStepLeft, setBackNextStepLeft] = useState([]);
  const [backNextStepRight, setBackNextStepRight] = useState([]);
  const [canDelete, setCanDelete] = useState(false);
  const [deletePosition, setDeletePosition] = useState([]);

  const [firstPlayerCircles, setFirstPlayerCircles] = useState([
    [0, 0, ""],
    [0, 1, ""],
    [0, 2, ""],
    [0, 3, ""],
    [1, 0, ""],
    [1, 1, ""],
    [1, 2, ""],
    [1, 3, ""],
    [2, 0, ""],
    [2, 1, ""],
    [2, 2, ""],
    [2, 3, ""],
  ]);
  const [secondPlayerCircles, setSecondPlayerCircles] = useState([
    [5, 0, ""],
    [5, 1, ""],
    [5, 2, ""],
    [5, 3, ""],
    [6, 0, ""],
    [6, 1, ""],
    [6, 2, ""],
    [6, 3, ""],
    [7, 0, ""],
    [7, 1, ""],
    [7, 2, ""],
    [7, 3, ""],
  ]);
  const [table, setTable] = useState([
    ["red", "red", "red", "red"],
    ["red", "red", "red", "red"],
    ["red", "red", "red", "red"],
    ["", "", "", ""],
    ["", "", "", ""],
    ["black", "black", "black", "black"],
    ["black", "black", "black", "black"],
    ["black", "black", "black", "black"],
  ]);

  const moveForward = (columnAndRow) => {
    let canPlay = false;
    if (activePlayer === false) {
      if (canDelete && columnAndRow[2]) {
        let circlesList = firstPlayerCircles;
        circlesList = circlesList.filter(
          (circle) =>
            !(
              circle[0] === deletePosition[0] && circle[1] === deletePosition[1]
            )
        );
        setFirstPlayerCircles(circlesList);
        table[deletePosition[0]][deletePosition[1]] = "";
        setDeletePosition([]);
        setCanDelete(false);
        canPlay = true;
        setActiveCircleForPlayAgain(columnAndRow);
      }
      let circlesList = secondPlayerCircles;
      circlesList = circlesList.filter(
        (circle) =>
          !(circle[0] === activeCircle[0] && circle[1] === activeCircle[1])
      );
      let singleCircle = secondPlayerCircles;
      singleCircle = singleCircle.filter(
        (circle) =>
          circle[0] === activeCircle[0] && circle[1] === activeCircle[1]
      );
      if (columnAndRow[0] === 0 && singleCircle[2] !== "king") {
        circlesList.push([columnAndRow[0], columnAndRow[1], "king"]);
      } else {
        circlesList.push([
          columnAndRow[0],
          columnAndRow[1],
          singleCircle[0][2],
        ]);
      }
      setSecondPlayerCircles(circlesList);
      table[activeCircle[0]][activeCircle[1]] = "";
      table[columnAndRow[0]][columnAndRow[1]] = "black";
    }
    if (activePlayer === true) {
      if (canDelete && columnAndRow[2]) {
        let circlesList = firstPlayerCircles;
        circlesList = circlesList.filter(
          (circle) =>
            !(
              circle[0] === deletePosition[0] && circle[1] === deletePosition[1]
            )
        );
        setFirstPlayerCircles(circlesList);
        table[deletePosition[0]][deletePosition[1]] = "";
        setDeletePosition([]);
        setCanDelete(false);
        canPlay = true;
        setActiveCircleForPlayAgain(columnAndRow);
      }
      let circlesList = firstPlayerCircles;
      circlesList = circlesList.filter(
        (circle) =>
          !(circle[0] === activeCircle[0] && circle[1] === activeCircle[1])
      );
      let singleCircle = firstPlayerCircles;
      singleCircle = singleCircle.filter(
        (circle) =>
          circle[0] === activeCircle[0] && circle[1] === activeCircle[1]
      );
      if (columnAndRow[0] === 7 && singleCircle[2] !== "king") {
        circlesList.push([columnAndRow[0], columnAndRow[1], "king"]);
      } else {
        circlesList.push([
          columnAndRow[0],
          columnAndRow[1],
          singleCircle[0][2],
        ]);
      }
      setFirstPlayerCircles(circlesList);
      table[activeCircle[0]][activeCircle[1]] = "";
      table[columnAndRow[0]][columnAndRow[1]] = "red";
    }
    if (canPlay) {
      setNextStepLeft([]);
      setNextStepRight([]);
      setBackNextStepLeft([]);
      setBackNextStepRight([]);
      return;
    }
    setActiveCircleForPlayAgain([]);
    setCanPlayAgain([]);
    setActiveCircle([]);
    setActivePlayer(!activePlayer);
    setNextStepLeft([]);
    setNextStepRight([]);
    setBackNextStepLeft([]);
    setBackNextStepRight([]);
  };

  const canMove = (column, row, onlyGet = false) => {
    let returnArray = [];
    if (activePlayer === false) {
      secondPlayerCircles.map((item) => {
        if (item[2] === "king") {
          if (item[0] === column && item[1] === row) {
            const positionLeft = table?.at(column - 1);
            const positionRight = table?.at(column - 1);
            const positionTopLeft = table?.at(column - 2);
            const positionTopRight = table?.at(column - 2);
            const canGetLeft = positionLeft?.at(row) === "red";
            const canGetRight = positionLeft?.at(row + 1) === "red";
            const canGetLeft2 = positionLeft?.at(row - 1) === "red";
            const canGetRight2 = positionLeft?.at(row) === "red";
            let moveLeft = false;
            let moveRight = false;
            setNextStepLeft([]);
            setNextStepRight([]);
            if (column % 2 === 1) {
              if (
                positionLeft?.at(row) !== undefined &&
                positionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column - 1, row, false]);
              }
              if (
                positionRight?.at(row + 1) !== undefined &&
                positionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column - 1, row + 1, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                positionLeft?.at(row - 1) !== undefined &&
                positionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column - 1, row - 1, false]);
              }
              if (
                positionRight?.at(row) !== undefined &&
                positionRight.at(row) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column - 1, row, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row - 1]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight2 &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
            }
            const backPositionLeft = table?.at(column + 1);
            const backPositionRight = table?.at(column + 1);
            const backPositionTopLeft = table?.at(column + 2);
            const backPositionTopRight = table?.at(column + 2);
            const backCanGetLeft = backPositionLeft?.at(row) === "red";
            const backCanGetRight = backPositionLeft?.at(row + 1) === "red";
            const backCanGetLeft2 = backPositionLeft?.at(row - 1) === "red";
            const backCanGetRight2 = backPositionLeft?.at(row) === "red";
            let backMoveLeft = false;
            let backMoveRight = false;
            setBackNextStepLeft([]);
            setBackNextStepRight([]);
            if (column % 2 === 1) {
              if (
                backPositionLeft?.at(row) !== undefined &&
                backPositionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                backMoveLeft = true;
                setBackNextStepLeft([column + 1, row, false]);
              }
              if (
                backPositionRight?.at(row + 1) !== undefined &&
                backPositionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                backMoveRight = true;
                setBackNextStepRight([column + 1, row + 1, false]);
              }
              if (
                backPositionTopLeft?.at(row - 1) !== undefined &&
                backPositionTopLeft.at(row - 1) === "" &&
                backMoveLeft === false &&
                backCanGetLeft &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setBackNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
              if (
                backPositionTopRight?.at(row + 1) !== undefined &&
                backPositionTopRight.at(row + 1) === "" &&
                backMoveRight === false &&
                backCanGetRight &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setBackNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                backPositionLeft?.at(row - 1) !== undefined &&
                backPositionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                backMoveLeft = true;
                setBackNextStepLeft([column + 1, row - 1, false]);
              }
              if (
                backPositionRight?.at(row) !== undefined &&
                backPositionRight.at(row) === "" &&
                onlyGet === false
              ) {
                backMoveRight = true;
                setBackNextStepRight([column + 1, row, false]);
              }
              if (
                backPositionTopLeft?.at(row - 1) !== undefined &&
                backPositionTopLeft.at(row - 1) === "" &&
                backMoveLeft === false &&
                backCanGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setBackNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row - 1]);
              }
              if (
                backPositionTopRight?.at(row + 1) !== undefined &&
                backPositionTopRight.at(row + 1) === "" &&
                backMoveRight === false &&
                backCanGetRight2 &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setBackNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
            }
          }
        } else {
          if (item[0] === column && item[1] === row) {
            const positionLeft = table?.at(column - 1);
            const positionRight = table?.at(column - 1);
            const positionTopLeft = table?.at(column - 2);
            const positionTopRight = table?.at(column - 2);
            const canGetLeft = positionLeft?.at(row) === "red";
            const canGetRight = positionLeft?.at(row + 1) === "red";
            const canGetLeft2 = positionLeft?.at(row - 1) === "red";
            const canGetRight2 = positionLeft?.at(row) === "red";
            let moveLeft = false;
            let moveRight = false;
            setNextStepLeft([]);
            setNextStepRight([]);
            if (column % 2 === 1) {
              if (
                positionLeft?.at(row) !== undefined &&
                positionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column - 1, row, false]);
              }
              if (
                positionRight?.at(row + 1) !== undefined &&
                positionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column - 1, row + 1, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                positionLeft?.at(row - 1) !== undefined &&
                positionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column - 1, row - 1, false]);
              }
              if (
                positionRight?.at(row) !== undefined &&
                positionRight.at(row) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column - 1, row, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row - 1]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight2 &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
            }
          }
        }
        return "";
      });
    }
    if (activePlayer === true) {
      firstPlayerCircles.map((item) => {
        if (item[2] === "king") {
          if (item[0] === column && item[1] === row) {
            const positionLeft = table?.at(column + 1);
            const positionRight = table?.at(column + 1);
            const positionTopLeft = table?.at(column + 2);
            const positionTopRight = table?.at(column + 2);
            const canGetLeft = positionLeft?.at(row) === "black";
            const canGetRight = positionLeft?.at(row + 1) === "black";
            const canGetLeft2 = positionLeft?.at(row - 1) === "black";
            const canGetRight2 = positionLeft?.at(row) === "black";
            let moveLeft = false;
            let moveRight = false;
            setNextStepLeft([]);
            setNextStepRight([]);
            if (column % 2 === 1) {
              if (
                positionLeft?.at(row) !== undefined &&
                positionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column + 1, row, false]);
              }
              if (
                positionRight?.at(row + 1) !== undefined &&
                positionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column + 1, row + 1, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                positionLeft?.at(row - 1) !== undefined &&
                positionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column + 1, row - 1, false]);
              }
              if (
                positionRight?.at(row) !== undefined &&
                positionRight.at(row) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column + 1, row, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row - 1]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight2 &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
            }
            const backPositionLeft = table?.at(column - 1);
            const backPositionRight = table?.at(column - 1);
            const backPositionTopLeft = table?.at(column - 2);
            const backPositionTopRight = table?.at(column - 2);
            const backCanGetLeft = backPositionLeft?.at(row) === "black";
            const backCanGetRight = backPositionLeft?.at(row + 1) === "black";
            const backCanGetLeft2 = backPositionLeft?.at(row - 1) === "black";
            const backCanGetRight2 = backPositionLeft?.at(row) === "black";
            let backMoveLeft = false;
            let backMoveRight = false;
            setBackNextStepLeft([]);
            setBackNextStepRight([]);
            if (column % 2 === 1) {
              if (
                backPositionLeft?.at(row) !== undefined &&
                backPositionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                backMoveLeft = true;
                setBackNextStepLeft([column - 1, row, false]);
              }
              if (
                backPositionRight?.at(row + 1) !== undefined &&
                backPositionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                backMoveRight = true;
                setBackNextStepRight([column - 1, row + 1, false]);
              }
              if (
                backPositionTopLeft?.at(row - 1) !== undefined &&
                backPositionTopLeft.at(row - 1) === "" &&
                backMoveLeft === false &&
                backCanGetLeft &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setBackNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
              if (
                backPositionTopRight?.at(row + 1) !== undefined &&
                backPositionTopRight.at(row + 1) === "" &&
                backMoveRight === false &&
                backCanGetRight &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setBackNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                backPositionLeft?.at(row - 1) !== undefined &&
                backPositionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                moveLeft = true;
                setBackNextStepLeft([column - 1, row - 1, false]);
              }
              if (
                backPositionRight?.at(row) !== undefined &&
                backPositionRight.at(row) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setBackNextStepRight([column - 1, row, false]);
              }
              if (
                backPositionTopLeft?.at(row - 1) !== undefined &&
                backPositionTopLeft.at(row - 1) === "" &&
                backMoveLeft === false &&
                backCanGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column - 2, row - 1, true]);
                setBackNextStepLeft([column - 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row - 1]);
              }
              if (
                backPositionTopRight?.at(row + 1) !== undefined &&
                backPositionTopRight.at(row + 1) === "" &&
                backMoveRight === false &&
                backCanGetRight2 &&
                row < 3
              ) {
                returnArray.push([column - 2, row + 1, true]);
                setBackNextStepRight([column - 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column - 1, row]);
              }
            }
          }
        } else {
          if (item[0] === column && item[1] === row) {
            const positionLeft = table?.at(column + 1);
            const positionRight = table?.at(column + 1);
            const positionTopLeft = table?.at(column + 2);
            const positionTopRight = table?.at(column + 2);
            const canGetLeft = positionLeft?.at(row) === "black";
            const canGetRight = positionLeft?.at(row + 1) === "black";
            const canGetLeft2 = positionLeft?.at(row - 1) === "black";
            const canGetRight2 = positionLeft?.at(row) === "black";
            let moveLeft = false;
            let moveRight = false;
            setNextStepLeft([]);
            setNextStepRight([]);
            if (column % 2 === 1) {
              if (
                positionLeft?.at(row) !== undefined &&
                positionLeft.at(row) === "" &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column + 1, row, false]);
              }
              if (
                positionRight?.at(row + 1) !== undefined &&
                positionRight.at(row + 1) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column + 1, row + 1, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row + 1]);
              }
            }
            if (column % 2 === 0) {
              if (
                positionLeft?.at(row - 1) !== undefined &&
                positionLeft.at(row - 1) === "" &&
                row > 0 &&
                onlyGet === false
              ) {
                moveLeft = true;
                setNextStepLeft([column + 1, row - 1, false]);
              }
              if (
                positionRight?.at(row) !== undefined &&
                positionRight.at(row) === "" &&
                onlyGet === false
              ) {
                moveRight = true;
                setNextStepRight([column + 1, row, false]);
              }
              if (
                positionTopLeft?.at(row - 1) !== undefined &&
                positionTopLeft.at(row - 1) === "" &&
                moveLeft === false &&
                canGetLeft2 &&
                row > 0
              ) {
                returnArray.push([column + 2, row - 1, true]);
                setNextStepLeft([column + 2, row - 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row - 1]);
              }
              if (
                positionTopRight?.at(row + 1) !== undefined &&
                positionTopRight.at(row + 1) === "" &&
                moveRight === false &&
                canGetRight2 &&
                row < 3
              ) {
                returnArray.push([column + 2, row + 1, true]);
                setNextStepRight([column + 2, row + 1, true]);
                setCanDelete(true);
                setDeletePosition([column + 1, row]);
              }
            }
          }
        }
        return "";
      });
    }
    return [returnArray];
  };

  useEffect(() => {
    if (activeCircleForPlayAgain.length > 0) {
      const stay = canMove(
        activeCircleForPlayAgain[0],
        activeCircleForPlayAgain[1],
        true
      );
      setCanPlayAgain(...stay);
      if (stay[0].length === 0) {
        setActiveCircleForPlayAgain([]);
        setActiveCircle([]);
        setCanPlayAgain([]);
        setActivePlayer(!activePlayer);
        setNextStepLeft([]);
        setNextStepRight([]);
      }
    }
    // eslint-disable-next-line
  }, [activeCircleForPlayAgain]);

  useEffect(() => {
    if (firstPlayerCircles.length === 0) {
      setTable([]);
      alert("Winner is player with black circles");
      window.location.reload(false);
    }
    if (secondPlayerCircles.length === 0) {
      setTable([]);
      alert("Winner is player with red circles");
      window.location.reload(false);
    }
    // eslint-disable-next-line
  }, [activePlayer]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-screen">
      <p className="absolute bottom-8 px-8 text-center text-xl">
        *Please note that game might have some errors while playing!
      </p>
      <div className="border drop-shadow-xl">
        <div className="flex flex-wrap w-[320px] lg:w-[640px]">
          {table.map((item, index) => (
            <div key={index} className="w-full flex">
              {item.map((row, indexRow) => (
                <div
                  key={indexRow}
                  className={`w-20 lg:w-40 h-10 lg:h-20 flex flex-row ${
                    (indexRow % 2 === 0 && index % 2 === 0) ||
                    (indexRow % 2 === 1 && index % 2 === 0)
                      ? "flex-row-reverse"
                      : ""
                  }`}
                >
                  <div className="w-10 lg:w-20 h-10 lg:h-20 border border-black bg-gray-200"></div>
                  <div className="w-10 lg:w-20 h-10 lg:h-20 border border-black bg-yellow-800 p-2">
                    <button
                      disabled={
                        (activePlayer === false && row === "red") ||
                        (activePlayer === true && row === "black") ||
                        (canPlayAgain.length === 1
                          ? !(
                              index === canPlayAgain[0][0] &&
                              indexRow === canPlayAgain[0][1]
                            )
                          : canPlayAgain.length === 2
                          ? !(
                              index === canPlayAgain[0][0] &&
                              indexRow === canPlayAgain[0][1]
                            ) &&
                            !(
                              index === canPlayAgain[1][0] &&
                              indexRow === canPlayAgain[1][1]
                            )
                          : false)
                      }
                      type="button"
                      onClick={() => {
                        canMove(index, indexRow);
                        setActiveCircle([index, indexRow]);
                        if (
                          nextStepRight[0] === index &&
                          nextStepRight[1] === indexRow
                        ) {
                          moveForward(nextStepRight);
                        }
                        if (
                          nextStepLeft[0] === index &&
                          nextStepLeft[1] === indexRow
                        ) {
                          moveForward(nextStepLeft);
                        }
                        if (
                          backNextStepRight[0] === index &&
                          backNextStepRight[1] === indexRow
                        ) {
                          moveForward(backNextStepRight);
                        }
                        if (
                          backNextStepLeft[0] === index &&
                          backNextStepLeft[1] === indexRow
                        ) {
                          moveForward(backNextStepLeft);
                        }
                      }}
                      className={`${
                        row === "black"
                          ? activeCircle[0] === index &&
                            activeCircle[1] === indexRow &&
                            !activePlayer
                            ? "bg-zinc-800 border-yellow-400"
                            : "bg-zinc-800 border-zinc-900"
                          : row === "red"
                          ? activeCircle[0] === index &&
                            activeCircle[1] === indexRow &&
                            activePlayer
                            ? "bg-red-600 border-yellow-400"
                            : "bg-red-600 border-red-700"
                          : (nextStepLeft[0] === index &&
                              nextStepLeft[1] === indexRow) ||
                            (nextStepRight[0] === index &&
                              nextStepRight[1] === indexRow) ||
                            (backNextStepLeft[0] === index &&
                              backNextStepLeft[1] === indexRow) ||
                            (backNextStepRight[0] === index &&
                              backNextStepRight[1] === indexRow)
                          ? "bg-yellow-700 border-yellow-600"
                          : "hidden"
                      } w-full h-full rounded-full border-2 lg:border-4 flex justify-center items-center`}
                    >
                      {firstPlayerCircles.map((circle, circleIndex) => {
                        if (
                          circle[0] === index &&
                          circle[1] === indexRow &&
                          circle[2] === "king"
                        ) {
                          return (
                            <svg
                              key={circleIndex}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="rgb(255,252,127)"
                              className="w-10 h-10"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
                              />
                            </svg>
                          );
                        }
                        return "";
                      })}
                      {secondPlayerCircles.map((circle, circleIndex) => {
                        if (
                          circle[0] === index &&
                          circle[1] === indexRow &&
                          circle[2] === "king"
                        ) {
                          return (
                            <svg
                              key={circleIndex}
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="rgb(255,252,127)"
                              className="w-10 h-10"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
                              />
                            </svg>
                          );
                        }
                        return "";
                      })}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default Game;
